import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import MFASetup from "./pages/MFASetup";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { RegionsProvider } from "./context/RegionsContext";
import { TenantProvider, useTenant } from "./context/TenantContext";
import TenantSelect from "./pages/TenantSelect";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import "./App.css";
import Profile from "./pages/Profile";
import MapView from "./pages/Maps.js";
import Filter from "./components/form_components/demo_form.js";
import DashboardLanding from "./pages/Home.js";
import VideoPlayerApp from "./pages/VideoPlayer.js";
import TrafficSpeedInsights from "./pages/TrafficSpeedInsights.js";
import UserCount from "./pages/Usercount.js";
import TurnCount from "./pages/TurnCount.js";
import Support from "./pages/Support.js";
import SpeedStats from "./pages/SpeedStats.js";
import ALPRSearch from "./pages/ALPRSearch";
// import ALPRSearch from './pages/alpr/ALPRSearch';
import HotList from './pages/alpr/HotList';
import Statistics from './pages/alpr/Statistics';
import AuditLogs from './pages/alpr/AuditLogs';
import AdminPortal from "./pages/admin/AdminPortal";
import Settings from "./pages/Settings.js";
import MFALogin from "./pages/MFALogin";
import RetentionPolicies from "./pages/admin/RetentionPolicies";


import ForgotPassword from "./pages/ForgotPassword.js";
import ResetPassword from "./pages/ResetPassword";
// Wrapper for authenticated routes that need regions data
function AuthenticatedRoutes() {
  const { user, mfaRequired  } = useAuth();
  const location = useLocation();
  if (!user) {
    return <Navigate to="/login" />;
  }
  if (mfaRequired && location.pathname !== '/mfa-setup') {
    return <Navigate to="/mfa-setup?required=true" />;
  }

  return (
    <TenantProvider>
      <TenantGate />
    </TenantProvider>
  );
}

// Gates data routes on an active customer. A multi-customer user (e.g. super
// admin) must pick one before any tenant-scoped data loads — the backend fails
// closed with 409 until then. RegionsProvider is keyed on the active customer
// so switching remounts it and refetches all region/system data fresh.
function TenantGate() {
  const { activeCustomerId, mustSelect, loading } = useTenant();

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        Loading...
      </div>
    );
  }

  if (mustSelect) {
    return <TenantSelect />;
  }

  return (
    <RegionsProvider key={activeCustomerId}>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/map" element={<MapView />} />
        <Route path="/filter" element={<Filter />} />
        <Route path="/home" element={<DashboardLanding />} />
        <Route path="/videos" element={<VideoPlayerApp />} />
        <Route path="/kpi/traffic-speed" element={<TrafficSpeedInsights />} />
        <Route path="/kpi/speed-stats" element={<SpeedStats />} />
        <Route path="/kpi/user-count" element={<UserCount />} />
        <Route path="/kpi/turn-count" element={<TurnCount />} />
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/support" element={<Support />} />
        <Route path="/admin-portal" element={<AdminPortal />} />

        <Route path="/mfa-setup" element={<MFASetup />} />
        <Route path="/admin/retention-policies" element={<RetentionPolicies />} />

        <Route path="/alpr-search" element={<ALPRSearch />} />
        <Route path="/alpr/hotlist" element={<HotList />} />
        <Route path="/alpr/statistics" element={<Statistics />} />
        <Route path="/alpr/audit-logs" element={<AuditLogs />} />
      </Routes>
    </RegionsProvider>
  );
}

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        Loading...
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/home" /> : <Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/login/mfa" element={<MFALogin />} />
        <Route path="/*" element={<AuthenticatedRoutes />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
